import React, { Component } from 'react'
import Header from '../Header'
import './XIIIs.css'

class XIIIs extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXIIIs">
                    <p className="textXIII">1944 - Jeux attribués à Londres, Royaume-Uni. Annulés à cause de la Seconde Guerre mondiale.</p>
                </div>
            </div>
        )
    }
}

export default XIIIs